import { RootState } from '../../store/rootReducer';

export const AuthorizationContentSelector = (state: RootState) => state.authorization;
